document.addEventListener("DOMContentLoaded", function () {
  // Tab functionality
  const tabs = document.querySelectorAll(".tab-btn");
  const contents = document.querySelectorAll(".tab-content");

  // 🔧 2026-09-18 兜底：`data-tab` 會喺客戶用 Shopify 後台儲存產品時被清走
  //    （填價／上架都會，實測 ADD6951 08:06 上架、同一秒 4 個 data-tab 全失）。
  //    一旦冇咗，原本嘅 querySelector 搵唔到掣，四格內容全部收起 → 前台一片空白。
  //    改為：搵唔到就按位置對 —— 第 i 個 .tab-btn 對第 i 個 .tab-content。
  //    HTML 有 data-tab 時行為完全不變，所以係純兜底，唔影響現有產品。
  const tabIdOf = (btn) => {
    if (btn && btn.dataset && btn.dataset.tab) return btn.dataset.tab;
    const i = Array.prototype.indexOf.call(tabs, btn);
    return i >= 0 && contents[i] ? contents[i].id : null;
  };
  const tabBtnFor = (tabId) => {
    const byAttr = document.querySelector(`.tab-btn[data-tab="${tabId}"]`);
    if (byAttr) return byAttr;
    const i = Array.prototype.findIndex.call(contents, (c) => c.id === tabId);
    return i >= 0 ? tabs[i] : null;
  };

  function setActiveTab(tabId) {
    tabs.forEach((t) => t.classList.remove("active"));
    contents.forEach((c) => c.classList.remove("active"));
    const activeTab = tabBtnFor(tabId);
    const activeContent = document.getElementById(tabId);
    if (activeTab && activeContent) {
      activeTab.classList.add("active");
      activeContent.classList.add("active");
    }
  }

  tabs.forEach((tab) => {
    tab.addEventListener("click", () => {
      setActiveTab(tabIdOf(tab));
    });
  });

  // Collapsible functionality (mobile)
  function toggleCollapsible(collapsible) {
    const content = collapsible.nextElementSibling;
    collapsible.classList.toggle("active");
    content.classList.toggle("active");
  }

  document.querySelectorAll(".template-product .collapsible").forEach((coll) => {
    coll.addEventListener("click", () => toggleCollapsible(coll));
  });

  function initializeCollapsibles() {
    if (window.innerWidth <= 727) {
      // Ensure all collapsibles are ready for mobile
      document.querySelectorAll(".template-product .collapsible").forEach((coll) => {
        coll.style.cursor = "pointer";
      });
      // 預設展開第一個摺疊欄（產品介紹／Description），其餘保持收合。
      // 註：手機 .collapsible 冇 data-tab，故直接取第一個（排序上即 Description）。
      const firstCollapsible = document.querySelector(".template-product .collapsible");
      if (firstCollapsible && !firstCollapsible.classList.contains("active")) {
        toggleCollapsible(firstCollapsible);
      }
    } else {
      // Reset all collapsibles in desktop view
      document.querySelectorAll(".template-product .collapsible, .template-product .tab-content").forEach((el) => {
        el.classList.remove("active");
      });
      // Set the default active tab based on the HTML structure
      const defaultActiveTab = document.querySelector(".tab-btn.active");
      if (defaultActiveTab) {
        setActiveTab(tabIdOf(defaultActiveTab));
      }
    }
  }

  // Run on load
  initializeCollapsibles();

  // Run when resizing the window
  window.addEventListener("resize", initializeCollapsibles);

  // FAQ functionality
  document.querySelectorAll(".faq-question").forEach((question) => {
    question.addEventListener("click", () => {
      const answer = question.nextElementSibling;
      answer.classList.toggle("active");
    });
  });

  // Add structured data
  function addStructuredData() {
    const productJson = document.getElementById("ProductJson-{{ section.id }}");
    if (!productJson) return;

    const product = JSON.parse(productJson.textContent);
    const productVariant = product.selected_or_first_available_variant;
    const structuredData = {
      "@context": "https://schema.org/",
      "@type": "Product",
      name: product.title,
      image: [
        product.featured_image
          ? `${window.location.origin}${product.featured_image}`
          : "",
      ],
      description: product.description,
      sku: productVariant.sku,
      mpn: productVariant.barcode,
      brand: {
        "@type": "Brand",
        name: product.vendor,
      },
      offers: {
        "@type": "Offer",
        url: window.location.href,
        priceCurrency: window.shop.currency,
        price: productVariant.price / 100,
        availability: productVariant.available
          ? "https://schema.org/InStock"
          : "https://schema.org/OutOfStock",
        priceValidUntil: new Date(
          new Date().setFullYear(new Date().getFullYear() + 1)
        )
          .toISOString()
          .split("T")[0],
      },
    };

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.text = JSON.stringify(structuredData);
    document.head.appendChild(script);
  }

  // Call the function to add structured data
  addStructuredData();
});